module.exports = __webpack_public_path__ + "img/athletics_icon_12.b134e28b.png";